module.exports = __webpack_public_path__ + "img/buddy_whiskers-02.053905db.svg";